import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {

  // --- ページ配列を計算 ---
  const createPageList = () => {
    const pages = [];

    const add = (p) => pages.push(p);

    const left = Math.max(1, currentPage - 2);
    const right = Math.min(totalPages, currentPage + 2);

    // 1ページ目
    add(1);

    // 左側の「…」
    if (left > 2) add("left-ellipsis");

    // 中央のページ
    for (let p = left; p <= right; p++) {
      if (p !== 1 && p !== totalPages) add(p);
    }

    // 右側の「…」
    if (right < totalPages - 1) add("right-ellipsis");

    // 最終ページ
    if (totalPages > 1) add(totalPages);

    return pages;
  };

  const pages = createPageList();

  return (
    <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mt={2}>
      {/* 前へ */}
      <Button
        size="small"
        variant="outlined"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        前へ
      </Button>

      {/* ページ番号 + … */}
      {pages.map((p, idx) =>
        p === "left-ellipsis" || p === "right-ellipsis" ? (
          <Typography key={idx} variant="body2" px={1} color="text.secondary">
            …
          </Typography>
        ) : (
          <Typography
            key={p}
            variant="body2"
            onClick={() => onPageChange(p)}
            sx={{
              cursor: p === currentPage ? "default" : "pointer",
              fontWeight: p === currentPage ? "bold" : "normal",
              color: p === currentPage ? "text.primary" : "primary.main",
              px: 1,
            }}
          >
            {p}
          </Typography>
        )
      )}

      {/* 次へ */}
      <Button
        size="small"
        variant="outlined"
        disabled={currentPage === totalPages || totalPages === 0}
        onClick={() => onPageChange(currentPage + 1)}
      >
        次へ
      </Button>
    </Stack>
  );
};

export default Pagination;
